import { gql } from '@lcs/shared/api';

export const getPhoneNumberDetail = gql`
   query GetPhoneNumberDetail($id: UInt!) {
      phoneNumber(id: $id) {
         phoneNumberId
         phoneNumber
         displayName
         scheduleId
         timeZoneId
         displayTimeZone
         account {
            accountId
            name
            timeZoneId
            schedule {
               name
            }
         }
         providerId
         isPorted
         openExtension {
            extensionId
            number
            name
         }
         closedExtension {
            extensionId
            number
            name
         }
         faxExtension {
            extensionId
            number
            name
         }
         schedule {
            scheduleId
            name
         }
         notes
         isActive
         datePorted
         isE911Registered
         portedComments
         allowOutboundCalls
         location {
            locationId
            name
            houseNumber
            directionalPrefix
            streetName
            streetNameSuffix
            directionalPostfix
            city
            state
            postalCode
            country
            timeZoneId
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
         phonesUsingForCallerIdConnection {
            items {
               extensionPhoneId
               displayName
               defaultPhoneNumberId
               extension {
                  extensionId
                  number
                  name
               }
            }
         }
         faxesUsingForCallerIdConnection {
            items {
               extensionFaxId
               defaultPhoneNumberId
               extension {
                  extensionId
                  number
                  name
               }
            }
         }
      }
   }
`;
